import { cn } from '#app/utils/misc.tsx'

function Skeleton({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn('animate-pulse duration-1500 rounded-md bg-muted', className)}
			{...props}
		/>
	)
}

export { Skeleton }
